export default "__VITE_ASSET__ZdhlJ6wq__"